import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { GALLERY } from "../mock";
import { useMedia, resolveUrl } from "../context/MediaContext";
import PageHero from "../components/PageHero";
import { EASE } from "../lib/motion";

export default function GalleryPage() {
  const { slots } = useMedia();
  const [active, setActive] = useState(null);

  return (
    <div className="bg-[#F7F2E9] min-h-screen">
      <PageHero
        eyebrow="A Visual Tour"
        title="The"
        accent="Gallery"
        image={resolveUrl(slots.hero)}
        subtitle="From the sparkling private pool to our cozy, thoughtfully designed interiors."
      />

      <div className="max-w-[1300px] mx-auto px-6 py-24">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          {GALLERY.map((g, i) => (
            <motion.button
              key={i}
              type="button"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.7, ease: EASE, delay: (i % 3) * 0.08 }}
              onClick={() => setActive(g)}
              data-cursor="hover"
              className="mb-5 w-full block overflow-hidden rounded-2xl shadow-lg group relative"
            >
              <img src={resolveUrl(slots[g.key])} alt={g.label} className="w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#06271D]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end">
                <span className="text-white font-display italic text-xl p-5">{g.label}</span>
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {active && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[200] bg-[#06271D]/95 backdrop-blur-sm flex items-center justify-center p-4"
            onClick={() => setActive(null)}
          >
            <button className="absolute top-6 right-6 text-white/80 hover:text-white" onClick={() => setActive(null)} aria-label="Close">
              <X size={34} />
            </button>
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.4, ease: EASE }}
              className="max-w-4xl w-full"
              onClick={(e) => e.stopPropagation()}
            >
              <img src={resolveUrl(slots[active.key])} alt={active.label} className="w-full max-h-[80vh] object-contain rounded-2xl" />
              <p className="text-center text-[var(--gold-light)] font-display italic text-xl mt-4">{active.label}</p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
